module.exports = require("swa-bootstrap-corporate-landing-home-page/air/stations-data");